const getGroupedStyle = (styles, position) => {
  if (!position) {
    return styles.ungrouped;
  }
  return styles[position];
};
const getDropdownClasses = (hasValue, isOpen, _dsf_grouped) => {
  const activeZIndex = hasValue ? ["focus:z-2", "hover:z-2", "active:z-2"] : ["focus-visible:z-2"];
  const whenOpen = isOpen ? "z-2" : "border-l-transparent";
  return getGroupedStyle(
    {
      first: ["border", "rounded-s-sm", ...activeZIndex],
      middle: ["border", ...activeZIndex, whenOpen],
      last: ["border", "rounded-e-sm", ...activeZIndex, whenOpen],
      ungrouped: ["border", "rounded-sm"]
    },
    _dsf_grouped
  );
};
export {
  getDropdownClasses,
  getGroupedStyle
};
